import { useRouteQuery, useTranslator } from '@/hooks'
import { ActivityLogTypeEnum } from '@/@data'
import Link from '@/components/Link'
import { LiftActivityLog } from '@/components/log/LiftActivityLog'

export const EmployeeDetailActivityLog = () => {
  const { __ } = useTranslator()
  const { params } = useRouteQuery();
  const { id } = params;

  return (
    <LiftActivityLog
      object_type={ActivityLogTypeEnum.User}
      object_id={id}
      breadcrumb={
        <Link color='inherit' href='/cms/users/employee'>
          {__('Employee Management')}
        </Link>
      }
    />
  )
}
